import React from "react";
import {
  FaInstagram,
  FaFacebook,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";
import { cdn_link } from "./constant";

const Footer = () => {
  const logo = cdn_link("smk_Logo3.png");
  return (
    <footer className="bg-gray-900 text-white py-10">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 px-4">
        {/* Section 1: Logo and Description */}
        <div className="space-y-4">
          <div className="text-3xl font-serif font-bold text-textgold ">
            <img
              src={logo}
              alt="SMK Decors Logo"
              className="h-24 w-auto logo-theme"
              loading="lazy"
            />
          </div>
          <h2 className="text-xl font-semibold">Celebrate Your Love With Us</h2>
          <p className="text-gray-300 text-justify">
            Home to the finest event planning and organizing, creating
            unforgettable celebrations with a touch of elegance and expertise.
          </p>
          <div className="flex space-x-4 mt-4">
            <a
              href="https://www.instagram.com/smkeventstudio"
              target="_blank"
              rel="noopener noreferrer"
              className="text-textgold hover:text-gold"
            >
              <FaInstagram size={24} />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-textgold hover:text-gold"
            >
              <FaFacebook size={24} />
            </a>
          </div>
        </div>

        {/* Section 2: Quick Links */}
        <div className="pl-0 sm:pl-12">
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2 text-gray-300">
            <li>
              <a href="/home" className="hover:text-textgold">
                Home
              </a>
            </li>
            <li>
              <a href="/aboutus" className="hover:text-textgold">
                About Us
              </a>
            </li>
            <li>
              <a href="/services" className="hover:text-textgold">
                Services
              </a>
            </li>
            {/* <li>
              <a href="/gallery" className="hover:text-textgold">
                Gallery
              </a>
            </li> */}
            <li>
              <a href="/contact" className="hover:text-textgold">
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Section 3: Services */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Our Services</h3>
          <ul className="space-y-2 text-gray-300">
            <li>
              <a href="/services/decor" className="hover:text-textgold">
                Event Decor and lighting
              </a>
            </li>
            <li>
              <a href="/services/catering" className="hover:text-textgold">
                Catering Services
              </a>
            </li>
            <li>
              <a href="/services/photography" className="hover:text-textgold">
                Photography and Videography
              </a>
            </li>
            <li>
              <a href="/services/entertainment" className="hover:text-textgold">
                Entertainment
              </a>
            </li>
            <li>
              <a href="/services/haldi" className="hover:text-textgold">
                Haldi
              </a>
            </li>
            <li>
              <a href="/services/sangeet" className="hover:text-textgold">
                Sangeet
              </a>
            </li>
            <li>
              <a href="/services/venue" className="hover:text-textgold">
                Venue Arrangement
              </a>
            </li>
            <li>
              <a href="/services/corporate" className="hover:text-textgold">
                Corporate Events
              </a>
            </li>
            <li>
              <a
                href="/services/other_services"
                className="hover:text-textgold"
              >
                Other Services
              </a>
            </li>
          </ul>
        </div>

        {/* Section 4: Contact Information */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
          <div className="flex items-center mb-2">
            <FaMapMarkerAlt className="text-textgold mr-4" />
            <p className="text-gray-300 pl-3">
              45/11, Nallithottam opposite street, Nasiyanur main road, Erode -
              638011
            </p>
          </div>
          <div className="flex items-center mb-2">
            <FaEnvelope className="text-textgold mr-2" />
            <p className="text-gray-300 pl-3">
              Email: smkeventstudio@gmail.com
            </p>
          </div>
          <div className="flex items-center mb-2">
            <FaPhone className="text-textgold mr-2" />
            <p className="text-gray-300 pl-3">Phone: +91 8883666618</p>
          </div>
        </div>
      </div>
      <div className="text-center text-gray-400 mt-10 flex justify-between ml-5 mr-5">
        <div className="p-2 sm:p-0">
          © {new Date().getFullYear()} SMK decors. All rights reserved.
        </div>
        <div className="p-2 sm:p-0">Powered by Apptastic Coders</div>
      </div>
    </footer>
  );
};

export default Footer;
